import { render } from "./ListIgnored.vue?vue&type=template&id=78be79d2&ts=true"
import script from "./ListIgnored.vue?vue&type=script&lang=ts"
export * from "./ListIgnored.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__